import { createContext } from "react";

const EventsContext = createContext(); // ✅ Crear el contexto correctamente

export default EventsContext;
